/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface MetierClauseLieeSearch
 */
export interface MetierClauseLieeSearch {
    /**
     * 
     * @type {number}
     * @memberof MetierClauseLieeSearch
     */
    idmetier?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MetierClauseLieeSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof MetierClauseLieeSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof MetierClauseLieeSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MetierClauseLieeSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof MetierClauseLieeSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof MetierClauseLieeSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the MetierClauseLieeSearch interface.
 */
export function instanceOfMetierClauseLieeSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetierClauseLieeSearchFromJSON(json: any): MetierClauseLieeSearch {
    return MetierClauseLieeSearchFromJSONTyped(json, false);
}

export function MetierClauseLieeSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetierClauseLieeSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function MetierClauseLieeSearchToJSON(value?: MetierClauseLieeSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idmetier': value.idmetier,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

